'use strict';
import angular from 'angular';
import { FlowinglyPermissions } from '@Shared.Angular/flowingly.services/flowingly.constants';

export default class TagGroupsHeaderComponentController {
  static $inject = ['permissionsService'];

  private showAddButton = false;
  private onAddButtonClick: () => void;

  constructor(private permissionsService) {
    this.showAddButton = this.permissionsService.currentUserHasPermission(
      FlowinglyPermissions.SETUP_TAG_UPDATE
    );
  }

  addButtonClick() {
    if (this.onAddButtonClick) {
      this.onAddButtonClick();
    }
  }
}

export class TagGroupsHeaderComponent implements angular.IComponentOptions {
  public templateUrl =
    'Client/runner.setup/runner.setup.taggroups/runner.setup.taggroups.header.tmpl.html';
  public bindings = {
    onAddButtonClick: '&'
  };
  controller = TagGroupsHeaderComponentController;
}

angular
  .module('flowingly.runner.setup')
  .component('tagGroupsHeader', new TagGroupsHeaderComponent());
